import { render } from "./ModalContents.vue?vue&type=template&id=3ae6601e"
import script from "./ModalContents.vue?vue&type=script&lang=js"
export * from "./ModalContents.vue?vue&type=script&lang=js"

import "./ModalContents.vue?vue&type=style&index=0&id=3ae6601e&lang=css"
script.render = render

export default script